/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

import { Helmet } from "react-helmet";

import moment from "moment";

import DataTable from "react-data-table-component";
import Input from "../../../components/input";

/* MATERIAL TAILWIND COMPONENTS */
import { Button, Dialog, DialogBody, Tooltip } from "@material-tailwind/react";

/* ICONS */
import { FiTrash } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { MdOutlineRemoveRedEye } from "react-icons/md";

/* TOAST NOTIFICATION */
import { toast } from "react-toast";

/* API IMPORT */
import {
  deleteContactUsDetailsById,
  deleteFileDetailsById,
  getUploadedFileList,
} from "../../../service/api";

const Uploads = () => {
  // STATE VARIABLES
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  const [uploadedFilesList, setUploadedFilesList] = useState([]);
  const [uploadedFilesListTemp, setUploadedFilesListTemp] = useState([]);

  const [totalDocs, setTotalDocs] = useState([]);

  const [search, setSearch] = useState("");

  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  const [viewModal, setViewModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);

  console.log("list", uploadedFilesList);

  /* FUNCTIONS */
  const handlePageChange = async (e) => {
    setPage(e);
    getUploadedFilesListFunction();
  };

  const handlePerPageChange = async (e) => {
    setSizePerPage(e);
    getUploadedFilesListFunction();
  };

  const getUploadedFilesListFunction = () => {
    setLoading(true);
    const params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination: true,
    };
    if (search) {
      params.search = search;
    }

    getUploadedFileList(params)
      .then((res) => {
        console.log("response", res);
        setUploadedFilesList(res?.data);
        setUploadedFilesListTemp(res?.data);
        setTotalDocs(res?.data?.length);
      })
      .catch((e) => {
        console.log("e-->", e);
      })
      .finally(() => {
        setLoading(false);
        setSearch("");
      });
  };

  /* HANDLE DELETE DATA */
  const handleDelete = () => {
    deleteFileDetailsById(deleteId)
      .then((res) => {
        toast.success(res?.message);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        setDeleteModal(!deleteModal);
        setDeleteId(null);
        getUploadedFilesListFunction();
      });
  };

  /* COLUMNS */
  const columns = [
    {
      name: "Sr. No",
      grow: 0.5,
      selector: (row, index) => (
        <span className="text-sm font-ibm-regular text-black text-opacity-60">
          {index + 1}
        </span>
      ),
    },
    {
      name: "Name",
      grow: 1.5,
      selector: (row) => (
        <p className="text-sm font-ibm-semibold text-black">
          {row?.user?.firstName} {row?.user?.lastName}
        </p>
      ),
    },
    {
      name: "Email",
      grow: 1.5,
      selector: (row) => (
        <>
          <a
            href={`mailto:${row.user?.email}`}
            className="block text-sm font-ibm-regular text-blue-500"
          >
            {row.user?.email}
          </a>
          <a
            href={`mailto:${row.user?.phone_number}`}
            className="block mt-1 text-sm font-ibm-regular text-blue-500"
          >
            {row.user?.phone_number}
          </a>
        </>
      ),
    },
    {
      name: "Uploaded file",
      grow: 1.5,
      selector: (row) => (
        <a
          href={row?.files[0]?.url}
          target="_blank"
          className="text-sm font-ibm-regular text-blue-500"
        >
          Click to view the file
        </a>
      ),
    },
    {
      name: "Requirements",
      grow: 2,
      selector: (row) => (
        <p className="text-sm font-ibm-regular text-greyText line-clamp-3">
          {row.user?.additional_requirements || "-"}
        </p>
      ),
    },

    {
      name: "Timestamp",
      grow: 1,
      selector: (row) => (
        <>
          <p className="text-sm font-ibm-regular text-greyText">
            {new Date(row?.user?.createdAt).toLocaleDateString("en-gb", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
          <p className="mt-1 text-sm font-ibm-regular text-greyText">
            {new Date(row?.user?.createdAt).toLocaleTimeString("en-gb", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </p>
        </>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="flex items-center">
          <Tooltip
            content="View details"
            className="text-sm font-ibm-regular text-white"
            key={row?.user?._id}
          >
            <Button
              onClick={() => {
                setSelectedContact(row);
                setViewModal(true);
              }}
              className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5"
            >
              <MdOutlineRemoveRedEye className="w-4 h-4 text-greyText" />
            </Button>
          </Tooltip>
          <Tooltip
            content="Remove"
            className="text-sm font-ibm-regular text-white"
            key={row?.user?._id}
          >
            <Button
              onClick={() => {
                setDeleteId(row?.user?._id);
                setDeleteModal(!deleteModal);
              }}
              className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5"
            >
              <FiTrash className="w-4 h-4 text-greyText" />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  /* USE-EFFECTS */
  useEffect(() => {
    getUploadedFilesListFunction();
  }, [page, sizePerPage]);

  /* LOADING SCREEN FOR DATATABLE */
  const LoadingScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-regular text-black text-center">
          Please wait!
        </p>
        <p className="mt-1 text-sm font-proxima-regular text-black text-center">
          We are fetching data.....
        </p>
      </div>
    );
  };

  const NoDataScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-semibold text-black text-center">
          There are no queries to display.
        </p>
      </div>
    );
  };

  const filterBySearch = () => {
    setLoading(true);

    if (!search.trim()) {
      setUploadedFilesList(uploadedFilesListTemp);
    } else {
      const searchLower = search.toLowerCase().replace(/\s+/g, "");

      const filteredResult = uploadedFilesListTemp.filter((item) => {
        const firstName = (item?.user?.firstName || "").toLowerCase();
        const lastName = (item?.user?.lastName || "").toLowerCase();
        const email = (item?.user?.email || "").toLowerCase();
        const fullNameWithSpace = `${firstName} ${lastName}`;
        const fullNameWithoutSpace = `${firstName}${lastName}`;

        return (
          fullNameWithSpace.includes(search.toLowerCase()) || // Match with spaces
          fullNameWithoutSpace.includes(searchLower) || // Match without spaces
          email.includes(search.toLowerCase()) // Match email (case-insensitive)
        );
      });

      setUploadedFilesList(filteredResult);
    }

    setLoading(false);
  };

  useEffect(() => {
    filterBySearch();
  }, [search]);

  return (
    <section className="px-0 py-2 xl:p-8 lg:p-8 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Uploads | P5 Graphics</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div className="block xl:flex lg:flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-ibm-bold text-black tracking-tight">
              Uploaded Designs
            </h1>
            <h2 className="text-base font-ibm-regular text-greyText tracking-tight">
              View and manage all uploaded design files from users in one place.
            </h2>
          </div>
          <div className="block xl:flex lg:flex items-center gap-2">
            {/* SEARCHBAR */}
            <div className="w-full xl:w-full lg:w-full mt-2 xl:mt-0 lg:mt-0">
              <Input
                type="text"
                placeholder="Search..."
                name="search"
                id="search"
                value={search}
                onChange={(e) => setSearch(e?.target?.value)}
              />
            </div>
          </div>
        </div>

        <div className="mt-5">
          <DataTable
            className="data-table"
            columns={columns}
            data={totalDocs > 0 ? uploadedFilesList : []}
            progressPending={loading}
            progressComponent={<LoadingScreen />}
            pagination
            paginationServer
            paginationTotalRows={totalDocs}
            onChangeRowsPerPage={handlePerPageChange}
            onChangePage={handlePageChange}
            noDataComponent={<NoDataScreen />}
          />
        </div>

        {/* DELETE MODAL */}
        <Dialog
          open={deleteModal}
          handler={() => setDeleteModal(!deleteModal)}
          size="xs"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0">
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-ibm-bold text-black tracking-tight">
                Delete Details
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setDeleteModal(!deleteModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              <p className="text-base font-ibm-regular text-black">
                Are you sure you want to delete this details?
              </p>
            </div>
            <div className="flex items-center justify-end px-5 py-3">
              <Button
                onClick={handleDelete}
                className="text-sm shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md font-proxima-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                Delete
              </Button>
            </div>
          </DialogBody>
        </Dialog>

        {/* VIEW MODAL */}
        <Dialog
          open={viewModal}
          handler={() => setViewModal(!viewModal)}
          size="xs"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
          className="rounded-lg max-h-[85vh] no-scrollbar"
        >
          <DialogBody className="p-8 relative">
            {selectedContact && (
              <div className="p-0">
                <p className="text-base font-ibm-regular">
                  Name:{" "}
                  <span className="text-base font-ibm-semibold text-black pl-1">
                    {selectedContact?.user?.firstName}{" "}
                    {selectedContact?.user?.lastName}
                  </span>
                </p>

                <p className="text-base font-ibm-regular mt-2">
                  File:{" "}
                  <a href={selectedContact?.files[0].url} target="_blank">
                    <span className="text-base font-ibm-semibold text-blue-600 pl-1">
                      click to view the file
                    </span>
                  </a>
                </p>

                <p className="mt-2 text-base font-ibm-regular">
                  Email address:{" "}
                  <a href={`mailto:${selectedContact?.user?.email}`}>
                    <span className="text-base font-ibm-semibold text-black pl-1">
                      {selectedContact?.user?.email}
                    </span>
                  </a>
                </p>

                <p className="mt-2 text-base font-ibm-regular">
                  Phone:{" "}
                  <a href={`tel:${selectedContact?.user?.phone_number}`}>
                    <span className="text-base font-ibm-semibold text-black pl-1">
                      {selectedContact?.user?.phone_number}
                    </span>
                  </a>
                </p>

                <p className="mt-2 text-base font-ibm-regular ">
                  Requirements:{" "}
                  <span className="text-base font-ibm-semibold text-black">
                    {selectedContact?.user?.additional_requirements}
                  </span>
                </p>

                <p className="mt-2 text-base font-ibm-regular ">
                  Timestamp:{" "}
                  <span className="text-base font-ibm-semibold text-black pl-1">
                    {moment(selectedContact.createdAt).format(
                      "MMM DD, YYYY HH:MM A"
                    )}
                  </span>
                </p>
              </div>
            )}

            <div className="absolute top-2 right-2">
              <Button
                onClick={() => setViewModal(!viewModal)}
                className="p-2 shadow-none hover:shadow-none bg-white hover:bg-black hover:bg-opacity-5 rounded-full transition-all duration-300 ease-in-out"
              >
                <IoClose className="w-5 h-5 text-greyText" />
              </Button>
            </div>
          </DialogBody>
        </Dialog>
      </div>
    </section>
  );
};

export default Uploads;
